import { PageId } from 'constants/pages'
import type { TPageConfig } from 'models/common.model'
import { PageIdIntl3 } from './pages'
import { HeaderId } from 'root-constants'

export const ID_TO_PAGE_CONFIG_MAP_INTL_3: Record<PageIdIntl3, TPageConfig> = {
  [PageId.ANALYZING_INTL_3]: {
    id: PageId.ANALYZING_INTL_3,
  },
  [PageId.START_INTL_3]: {
    id: PageId.START_INTL_3,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
    legalNotice: 'fixed',
  },
  [PageId.PUZZLES_ENJOYMENT_INTL_3]: {
    id: PageId.PUZZLES_ENJOYMENT_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.APPLY_KNOWLEDGE_REAL_LIFE_INTL_3]: {
    id: PageId.APPLY_KNOWLEDGE_REAL_LIFE_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.NOTICE_PATTERNS_INTL_3]: {
    id: PageId.NOTICE_PATTERNS_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.STAY_CURIOUS_INTL_3]: {
    id: PageId.STAY_CURIOUS_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.LONG_FOCUS_INTL_3]: {
    id: PageId.LONG_FOCUS_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.PERSONALIZE_TEST_FEEDBACK_INTL_3]: {
    id: PageId.PERSONALIZE_TEST_FEEDBACK_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.QUESTION_1_INTL_3]: {
    id: PageId.QUESTION_1_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_2_INTL_3]: {
    id: PageId.QUESTION_2_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_3_INTL_3]: {
    id: PageId.QUESTION_3_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_4_INTL_3]: {
    id: PageId.QUESTION_4_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.SPEED_FEEDBACK_INTL_3]: {
    id: PageId.SPEED_FEEDBACK_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.QUESTION_5_INTL_3]: {
    id: PageId.QUESTION_5_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_6_INTL_3]: {
    id: PageId.QUESTION_6_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_7_INTL_3]: {
    id: PageId.QUESTION_7_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_8_INTL_3]: {
    id: PageId.QUESTION_8_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_9_INTL_3]: {
    id: PageId.QUESTION_9_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_10_INTL_3]: {
    id: PageId.QUESTION_10_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_11_INTL_3]: {
    id: PageId.QUESTION_11_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_12_INTL_3]: {
    id: PageId.QUESTION_12_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.SMARTNESS_FEEDBACK_INTL_3]: {
    id: PageId.SMARTNESS_FEEDBACK_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.QUESTION_13_INTL_3]: {
    id: PageId.QUESTION_13_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_14_INTL_3]: {
    id: PageId.QUESTION_14_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_15_INTL_3]: {
    id: PageId.QUESTION_15_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_16_INTL_3]: {
    id: PageId.QUESTION_16_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_17_INTL_3]: {
    id: PageId.QUESTION_17_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_18_INTL_3]: {
    id: PageId.QUESTION_18_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_19_INTL_3]: {
    id: PageId.QUESTION_19_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_20_INTL_3]: {
    id: PageId.QUESTION_20_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.LOGICAL_SKILLS_FEEDBACK_INTL_3]: {
    id: PageId.LOGICAL_SKILLS_FEEDBACK_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.QUESTION_21_INTL_3]: {
    id: PageId.QUESTION_21_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_22_INTL_3]: {
    id: PageId.QUESTION_22_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_23_INTL_3]: {
    id: PageId.QUESTION_23_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_24_INTL_3]: {
    id: PageId.QUESTION_24_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_25_INTL_3]: {
    id: PageId.QUESTION_25_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.AGE_QUESTION_INTL_3]: {
    id: PageId.AGE_QUESTION_INTL_3,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.EDUCATION_QUESTION_INTL_3]: {
    id: PageId.EDUCATION_QUESTION_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.DISCOVER_FEEDBACKS_INTL_3]: {
    id: PageId.DISCOVER_FEEDBACKS_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.PREPARE_FLOW_INTL_3]: {
    id: PageId.PREPARE_FLOW_INTL_3,
    hasHeader: true,
    headerId: HeaderId.LOGO_ONLY,
  },
  [PageId.EMAIL_INTL_3]: {
    id: PageId.EMAIL_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.OFFER_INTL_3]: {
    id: PageId.OFFER_INTL_3,
  },
  [PageId.SPECIAL_DISCOUNT_INTL_3]: {
    id: PageId.SPECIAL_DISCOUNT_INTL_3,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.CANCEL_OFFER_INTL_3]: {
    id: PageId.CANCEL_OFFER_INTL_3,
  },
  [PageId.PAYMENT_INTL_3]: {
    id: PageId.PAYMENT_INTL_3,
  },
  [PageId.REGISTRATION_INTL_3]: {
    id: PageId.REGISTRATION_INTL_3,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageId.NAME_ENTRY_INTL_3]: {
    id: PageId.NAME_ENTRY_INTL_3,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageId.CERTIFICATE_INTL_3]: {
    id: PageId.CERTIFICATE_INTL_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.REPORT_INTL_3]: {
    id: PageId.REPORT_INTL_3,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
}
